import { CSSProperties, FC } from "react";

const moveRight = 150;

export interface MascotGDPRProps {
  mode: "light" | "dark";
  style?: CSSProperties;
}

export const MascotGDPR: FC<MascotGDPRProps> = (props) => {
  const hairColor = props.mode === "dark" ? "#fff" : "#fff";
  return (
    <svg
      version="1.1"
      viewBox={`-${moveRight} 0 ${319.21 + moveRight * 2.5} 385.15`}
      xmlns="http://www.w3.org/2000/svg"
      style={props.style}
      className={"MascotGDPR"}
    >
      <defs id="defs428">
        <style id="style426">
          {`.st0 {
            font-size: 55.42px;
          }

            .st0, .st1, .st2, .st3, .st4 {
            stroke-miterlimit: 10;
          }

            .st0, .st3, .st4 {
            fill: #47af6e;
            font-family: Helvetica-Bold, Helvetica;
            font-weight: 700;
            stroke: #47af6e;
          }

            .st5 {
            fill: #9cc;
          }

            .st1 {
            fill: #231f20;
            stroke: #231f20;
            stroke-width: .86px;
          }

            .st6 {
            fill: #98cbcb;
          }

            .st7 {
            fill: #e1f1ef;
          }

            .st8, .st9 {
            fill: #211e1f;
          }

            .st2 {
            stroke: #000;
            stroke-width: .03px;
          }

            .st10 {
            fill: #fff;
          }

            .st3 {
            font-size: 39.51px;
            stroke-width: .45px;
          }

            .st9 {
            display: none;
          }

            .st4 {
            font-size: 54.56px;
            stroke-width: 1.86px;
          }`}
        </style>
      </defs>
      <path
        className="st7"
        d="M255.83,80.4c-5.38-39.2-55.98-57.92-86.58-33.92-16.48,15.83-17.35-8.78-32.48-13.31-12.95-2.62-19.58,12.81-32.3,9.98-11.12-2.48-10.46-15.25-21.52-17.53-12.29-2.53-16.82,9.13-32.41,9.94-10.74.56-16.35-16.57-33.19-11.42-34.3,10.5-13.32,58.38,24.07,38.9,4.39-2.29,9.44-6.77,15.6-5.9,10.64,1.5,11.7,14.8,22.37,17.85,12.24,3.5,18.37-11.85,32.3-9.99,15.07,2.02,16.35,20.62,31.27,23,12.76,2.03,18.92-12.72,31.22-10.16,11.41,1.94,13.52,19.18,17.66,27.56,19.88,44.36,72.18,18.89,63.97-24.99Z"
        id="path430"
      />
      <g id="g444">
        <g id="g436">
          <path
            className="st5"
            d="M224,411.78l-14.15.64-5.03.23-88.67,4.09,18.05-31.65,53.44,11.44-45.31-48.91c6.11-3.97,12.26-7.92,18.37-11.9.09-.05.16-.11.25-.16,7.56-4.89,37.32-24.82,44.37-29.39,10.17.55,10.7,6.59,17.32,11.92-5.58,4.02-20.92,13.32-26.75,17.48-.09.05-.16.11-.23.16-7.3,5.24-14.58,10.52-21.89,15.75l38.14,45.81,3.17,3.81,8.91,10.68Z"
            id="path432"
          />
          <path
            className="st2"
            d="M222.65,318.08c-5.58,4.02-20.92,13.32-26.75,17.48h-34.93c7.56-4.89,37.32-24.82,44.37-29.39,10.17.55,10.7,6.59,17.32,11.92Z"
            id="path434"
          />
        </g>
        <g id="g442">
          <path
            className="st5"
            d="M228.95,411.78l14.15.64,5.03.23,88.67,4.09-18.05-31.65-53.44,11.44,45.31-48.91c-6.11-3.97-12.26-7.92-18.37-11.9-.09-.05-.16-.11-.25-.16-7.56-4.89-37.32-24.82-44.37-29.39-10.17.55-10.7,6.59-17.32,11.92,5.58,4.02,20.92,13.32,26.75,17.48.09.05.16.11.23.16,7.3,5.24,14.58,10.52,21.89,15.75l-38.14,45.81-3.17,3.81-8.91,10.68Z"
            id="path438"
          />
          <path
            className="st2"
            d="M230.3,318.08c5.58,4.02,20.92,13.32,26.75,17.48h34.93c-7.56-4.89-37.32-24.82-44.37-29.39-10.17.55-10.7,6.59-17.32,11.92Z"
            id="path440"
          />
        </g>
      </g>
      <path
        className="st6"
        d="m 132.27,138.29 h 188.42 v 165.57 c 0,12.61 -10.24,22.85 -22.85,22.85 H 155.12 c -12.61,0 -22.85,-10.24 -22.85,-22.85 z"
        id="path446"
      />
      <rect
        className="st6"
        x="98.610001"
        y="117.95"
        width="255.73"
        height="49.299999"
        id="rect448"
      />
      <rect
        x="185.29"
        y="171.83"
        width="81.17"
        height="7.48"
        rx="3.74"
        ry="3.74"
        transform="translate(-35.27 58.74) rotate(-13.75)"
        id="rect452"
      />
      <g id="g466">
        <path
          className="st10"
          d="M269.26,215.68c0,3.75-1.06,7.26-2.89,10.23h-33.28c-1.83-2.98-2.89-6.48-2.89-10.23,0-10.79,8.74-19.53,19.53-19.53,10.79,0,19.53,8.74,19.53,19.53Z"
          id="path454"
        />
        <path
          className="st10"
          d="M223.24,215.68c0,3.75-1.06,7.26-2.89,10.23h-33.28c-1.83-2.98-2.89-6.48-2.89-10.23,0-10.79,8.74-19.53,19.53-19.53,10.79,0,19.53,8.74,19.53,19.53Z"
          id="path456"
        />
        <circle
          className="st9"
          cx="203.7"
          cy="217.36"
          r="4.65"
          id="circle458"
        />
        <circle
          className="st9"
          cx="249.73"
          cy="217.36"
          r="4.65"
          id="circle460"
        />
        <ellipse
          className="st8"
          cx="249.73"
          cy="212.76"
          rx="4.65"
          ry="7.34"
          transform="translate(-23.71 31.47) rotate(-6.89)"
          id="ellipse462"
        />
        <ellipse
          className="st8"
          cx="203.7"
          cy="212.76"
          rx="7.34"
          ry="4.65"
          transform="translate(-31.94 389.49) rotate(-83.11)"
          id="ellipse464"
        />
      </g>
      <g id="g2186" transform="translate(6)">
        <g
          id="g2071"
          transform="matrix(0.70161307,0,0,0.60955982,46.637222,107.50423)"
        >
          <rect
            className="st1"
            x="211.75999"
            y="251.72"
            width="11.1"
            height="13.49"
            id="rect468"
          />
          <rect
            className="st1"
            x="190.31"
            y="251.28"
            width="11.1"
            height="13.49"
            id="rect470"
          />
          <rect
            className="st1"
            x="235.19"
            y="251.72"
            width="11.1"
            height="13.49"
            id="rect472"
          />
          <rect
            className="st1"
            x="246.67999"
            y="261.47"
            width="11.1"
            height="13.49"
            id="rect476"
          />
          <rect
            className="st1"
            x="223.44"
            y="261.47"
            width="11.1"
            height="13.49"
            id="rect478"
          />
          <rect
            className="st1"
            x="200.21001"
            y="261.47"
            width="11.1"
            height="13.49"
            id="rect480"
          />
        </g>
        <g id="g2169">
          <rect
            className="st1"
            x="243.01205"
            y="260.90723"
            width="7.7879052"
            height="8.2229614"
            id="rect468-3"
            fill="#231f20"
            stroke="#231f20"
            strokeWidth="0.562413"
            strokeMiterlimit="10"
          />
          <rect
            className="st1"
            x="227.96245"
            y="260.63901"
            width="7.7879052"
            height="8.2229614"
            id="rect470-3"
            fill="#231f20"
            stroke="#231f20"
            strokeWidth="0.562413"
            strokeMiterlimit="10"
          />
          <rect
            className="st1"
            x="251.20689"
            y="266.85043"
            width="7.7879052"
            height="8.2229614"
            id="rect478-8"
            fill="#231f20"
            stroke="#231f20"
            strokeWidth="0.562413"
            strokeMiterlimit="10"
          />
          <rect
            className="st1"
            x="234.90843"
            y="266.85043"
            width="7.7879052"
            height="8.2229614"
            id="rect480-3"
            fill="#231f20"
            stroke="#231f20"
            strokeWidth="0.562413"
            strokeMiterlimit="10"
          />
        </g>
        <g
          id="g2143"
          transform="matrix(0.69956235,0,0,0.69683573,44.98724,88.156992)"
        >
          <path
            d="m 188,261.05 -0.2,-0.44 c -2.32,-5.09 -8.04,-7.52 -12.71,-5.4 l -18.1,8.24 c -0.91,0.41 -1.28,1.56 -0.83,2.55 l 6.99,15.36 c 0.45,0.99 1.56,1.46 2.47,1.05 l 18.1,-8.24 c 4.67,-2.13 6.6,-8.03 4.28,-13.13 z m -9.12,-1.77 c 1.25,-0.57 2.79,0.08 3.41,1.45 l 2.01,4.41 c 0.62,1.37 0.1,2.95 -1.15,3.52 l -1.09,0.49 c -1.23,0.56 -2.73,-0.08 -3.34,-1.42 l -2.05,-4.51 c -0.61,-1.34 -0.1,-2.89 1.13,-3.45 l 1.09,-0.49 z m -11.54,18.26 c -0.11,0.05 -0.25,0 -0.3,-0.13 l -5.34,-11.74 c -0.05,-0.12 0,-0.26 0.1,-0.31 l 3.26,-1.48 c 1.5,-0.68 3.34,0.1 4.08,1.73 l 2.83,6.23 c 0.74,1.64 0.13,3.53 -1.38,4.22 l -3.26,1.48 z"
            id="path482"
          />
          <path
            d="m 188.6,254.32 h 3.68 c 1.19,0 2.15,0.96 2.15,2.15 v 8.29 h -7.97 v -8.29 c 0,-1.19 0.96,-2.15 2.15,-2.15 z"
            transform="rotate(65.54,190.43682,259.50552)"
            id="path484"
          />
        </g>
      </g>
      <text
        className="st0"
        transform="translate(252.71 57.23)"
        id="text488"
        fill="#98cbcb"
        fillOpacity="1"
        stroke="#98cbcb"
        strokeOpacity="1"
      >
        <tspan
          x="0"
          y="0"
          id="tspan486"
          fill="#98cbcb"
          fillOpacity="1"
          stroke="#98cbcb"
          strokeOpacity="1"
        >
          ?
        </tspan>
      </text>
      <text
        className="st4"
        transform="translate(217.31 83.67)"
        id="text492"
        fill="#98cbcb"
        fillOpacity="1"
        stroke="#98cbcb"
        strokeOpacity="1"
      >
        <tspan
          x="0"
          y="0"
          id="tspan490"
          fill="#98cbcb"
          fillOpacity="1"
          stroke="#98cbcb"
          strokeOpacity="1"
        >
          ?
        </tspan>
      </text>
      <text
        className="st3"
        transform="translate(232.04 34.2)"
        id="text496"
        fill="#98cbcb"
        fillOpacity="1"
        stroke="#98cbcb"
        strokeOpacity="1"
      >
        <tspan
          x="0"
          y="0"
          id="tspan494"
          fill="#98cbcb"
          fillOpacity="1"
          stroke="#98cbcb"
          strokeOpacity="1"
        >
          ?
        </tspan>
      </text>
    </svg>
  );
};
